<template>
  <div id="app_wrapper">
    <div id="main_menu">
      <img src="@/assets/img/prometco-logo.png" id="logo" />

      <div class="menu_item" :class="{selected: current_section == 1}" @click="set_section(1)">
        <div class="menu_icon icon_01"></div>
        <p>Baseline characteristics</p>
      </div>

      <div class="menu_item" :class="{selected: current_section == 2}" @click="set_section(2)">
        <div class="menu_icon icon_02"></div>
        <p>Safety outcomes</p>
      </div>

      <div class="menu_item" :class="{selected: current_section == 3}" @click="set_section(3)">
        <div class="menu_icon icon_03"></div>
        <p>Conclusions</p>
      </div>
    </div>

    <div class="top_icon" :class="get_icon_class"></div>
    <div class="top_nav_wrapper" :class="{'conclusions' : current_animation == 'conclusions'}">
      <h1 v-if="current_animation == 'conclusions'">Conclusions</h1>

      <div class="top_nav" v-if="current_section == 1">
        <button :class="{selected: (current_animation == 'baseline_01')}" @click="set_graph('baseline_01')">ECOG PS</button>

        <button :class="{selected: (current_animation == 'bc_age' || current_animation == 'bc_sex')}" @click="set_graph('bc_age')">Age and sex</button>
        
        <button :class="{selected: (current_animation == 'bc_ras' || current_animation == 'bc_msi')}" @click="set_graph('bc_ras')">Biomolecular status</button>
        <button :class="{selected: (current_animation == 'bc_meta' || current_animation == 'bc_ds' || current_animation == 'bc_type')}" @click="set_graph('bc_meta')">Disease characteristics</button>
        <!--<button :class="{selected: (current_animation == 'bc_prior' || current_animation == 'bc_prior_radio')}" @click="set_graph('bc_prior')">Prior treatment</button>-->
      </div>

      <div class="top_nav" v-if="current_section == 2">
        <button :class="{selected: (current_animation == 'safety_01')}" @click="set_graph('safety_01')" class="ls-1">AEs in the overall and FTD/TPI populations</button>
        <button :class="{selected: (current_animation == 'safety_02')}" @click="set_graph('safety_02')" class="ls-1">Most frequently occurring AEs in overall population</button>
        <button :class="{selected: (current_animation == 'safety_03-ae-summary')}" @click="set_graph('safety_03-ae-summary')" class="ls-1">AEs in patients who received FTD/TPI by ECOG PS</button>
      </div>
      

      <div class="sub_nav" v-show="(current_animation == 'bc_age' || current_animation == 'bc_sex')">
        <button :class="{selected: current_animation == 'bc_age'}" @click="set_graph('bc_age')">Age</button>
        <button :class="{selected: current_animation == 'bc_sex'}" @click="set_graph('bc_sex')">Sex</button>
      </div>

      <div class="sub_nav" v-show="(current_animation == 'bc_ras' || current_animation == 'bc_msi')">
        <button :class="{selected: current_animation == 'bc_ras'}" @click="set_graph('bc_ras')"><em>RAS/BRAF</em></button>
        <button :class="{selected: current_animation == 'bc_msi'}" @click="set_graph('bc_msi')">MSI/MSS</button>
      </div>

      <div class="sub_nav" v-show="(current_animation == 'bc_meta' || current_animation == 'bc_ds' || current_animation == 'bc_stage' || current_animation == 'bc_time')">
        <button :class="{selected: current_animation == 'bc_meta'}" @click="set_graph('bc_meta')">Metastatic site location</button>
        <button :class="{selected: current_animation == 'bc_ds'}" @click="set_graph('bc_ds')">Disease sidedness</button>
        <button :class="{selected: current_animation == 'bc_stage'}" @click="set_graph('bc_stage')">CRC stage at initial diagnosis</button>
        <button :class="{selected: current_animation == 'bc_time'}" @click="set_graph('bc_time')">Time since CRC initial diagnosis</button>
      </div>

      <div class="sub_nav" v-show="(current_animation == 'bc_prior' || current_animation == 'bc_prior_radio')">
        <button :class="{selected: current_animation == 'bc_prior'}" @click="set_graph('bc_prior')">Prior surgery</button>
        <button :class="{selected: current_animation == 'bc_prior_radio'}" @click="set_graph('bc_prior_radio')">Prior radiotherapy</button>
      </div>


      <div class="sub_nav" v-show="(current_animation == 'safety_03-ae-summary' || current_animation == 'safety_03-hema-aes' || current_animation == 'safety_03-non-hema-aes')">
        <button :class="{selected: current_animation == 'safety_03-ae-summary'}" @click="set_graph('safety_03-ae-summary')">AE summary</button>
        <button :class="{selected: current_animation == 'safety_03-hema-aes'}" @click="set_graph('safety_03-hema-aes')">Hematologic AEs</button>
        <button :class="{selected: current_animation == 'safety_03-non-hema-aes'}" @click="set_graph('safety_03-non-hema-aes')">Non-hematologic AEs</button>
      </div>
    </div>

    <div id="main_content">
      
      <Vue3Lottie assetsPath="/anim2025/graphs/baseline_01/images/" :loop="false" :animationData="baseline_01_JSON" :width="980" :height="520" v-if="current_animation == 'baseline_01'" autoPlay="true" />
      <Vue3Lottie assetsPath="/anim2025/graphs/baseline_02-age/images/" :loop="false" :animationData="baseline_02age_JSON" :width="980" :height="520" v-if="current_animation == 'bc_age'" autoPlay="true" />
      <Vue3Lottie assetsPath="/anim2025/graphs/baseline_02-sex/images/" :loop="false" :animationData="baseline_02sex_JSON" :width="980" :height="520" v-if="current_animation == 'bc_sex'" />
      <Vue3Lottie assetsPath="/anim2025/graphs/baseline_03-ras/images/" :loop="false" :animationData="baseline_03ras_JSON" :width="980" :height="520" v-if="current_animation == 'bc_ras'" :autoPlay="true" ref="baseline_03-ras" />
      <Vue3Lottie assetsPath="/anim2025/graphs/baseline_03-msi/images/" :loop="false" :animationData="baseline_03msi_JSON" :width="980" :height="520" v-if="current_animation == 'bc_msi'" />
      <Vue3Lottie assetsPath="/anim2025/graphs/baseline_dc-meta/images/" :loop="false" :animationData="baseline_dcmeta_JSON" :width="980" :height="520" v-if="current_animation == 'bc_meta'" />
      <Vue3Lottie assetsPath="/anim2025/graphs/baseline_dc-ds/images/" :loop="false" :animationData="baseline_dcds_JSON" :width="980" :height="520" v-if="current_animation == 'bc_ds'" />

      <Vue3Lottie assetsPath="/anim2025/graphs/baseline_dc-crc-stage/images/" :loop="false" :animationData="baseline_dccrcstage_JSON" :width="980" :height="520" v-if="current_animation == 'bc_stage'" />
      <Vue3Lottie assetsPath="/anim2025/graphs/baseline_dc-time-since/images/" :loop="false" :animationData="baseline_dctimesince_JSON" :width="980" :height="520" v-if="current_animation == 'bc_time'" />

      <Vue3Lottie assetsPath="/anim2025/graphs/safety_01/images/" :loop="false" :animationData="safety_01_JSON" :width="980" :height="520" v-if="current_animation == 'safety_01'" />
      <Vue3Lottie assetsPath="/anim2025/graphs/safety_02/images/" :loop="false" :animationData="safety_02_JSON" :width="980" :height="520" v-if="current_animation == 'safety_02'" />

      <Vue3Lottie assetsPath="/anim2025/graphs/safety_03-ae-summary/images/" :loop="false" :animationData="safety_03aesummary_JSON" :width="980" :height="520" v-if="current_animation == 'safety_03-ae-summary'" ref="safety_03-ae-summary" :autoPlay="true" />
      <Vue3Lottie assetsPath="/anim2025/graphs/safety_03-hema-aes/images/" :loop="false" :animationData="safety_03hemaaes_JSON" :width="980" :height="520" v-if="current_animation == 'safety_03-hema-aes'" ref="safety_03-hema-aes" :autoPlay="true" />
      <Vue3Lottie assetsPath="/anim2025/graphs/safety_03-non-hema-aes/images/" :loop="false" :animationData="safety_03nonhemaaes_JSON" :width="980" :height="520" v-if="current_animation == 'safety_03-non-hema-aes'" ref="safety_03-non-hema-aes" :autoPlay="true" />

      <Vue3Lottie assetsPath="/anim2025/graphs/conclusions/images/" :loop="false" :animationData="conclusions_JSON" :width="980" :height="520" v-if="current_animation == 'conclusions'" ref="conclusions" :autoPlay="true" />
      
      <img src="/anim2025/conclusions_01.png" width="980" v-show="int_1_conc_shown" class="overlay_conc" />
      <img src="/anim2025/conclusions_02.png" width="980" v-show="int_2_conc_shown" class="overlay_conc2" />
    </div>
    

    <div id="footer">
      <div class="servier_logo"></div>
      <p>PROMETCO: Real-world characteristics and safety outcomes of patients with metastatic colorectal cancer (mCRC) after two disease progressions, including patients with an ECOG PS &ge;2</p>
    </div>

    <div class="conc_btn" v-if="current_animation == 'safety_03-ae-summary'">
        <div class="iBtn" id="iBtn1" @click="int_click(1, 1)"></div>
    </div>
    <div class="conc_btn" v-if="current_animation == 'bc_meta'">
        <div class="iBtn" id="iBtn2" @click="int_click(1, 2)"></div>
    </div>

  </div>
</template>

<script>
import { Vue3Lottie } from 'vue3-lottie'



import baseline_01_JSON from '@/assets/graphs/baseline_01/data.json'
import baseline_02age_JSON from '@/assets/graphs/baseline_02-age/data.json'
import baseline_02sex_JSON from '@/assets/graphs/baseline_02-sex/data.json'
import baseline_03msi_JSON from '@/assets/graphs/baseline_03-msi/data.json'
import baseline_03ras_JSON from '@/assets/graphs/baseline_03-ras/data.json'
import baseline_dccrcstage_JSON from '@/assets/graphs/baseline_dc-crc-stage/data.json'
import baseline_dcds_JSON from '@/assets/graphs/baseline_dc-ds/data.json'

import baseline_dcmeta_JSON from '@/assets/graphs/baseline_dc-meta/data.json'
import baseline_dctimesince_JSON from '@/assets/graphs/baseline_dc-time-since/data.json'

import conclusions_JSON from '@/assets/graphs/conclusions/data.json'
import safety_01_JSON from '@/assets/graphs/safety_01/data.json'
import safety_02_JSON from '@/assets/graphs/safety_02/data.json'
import safety_03aesummary_JSON from '@/assets/graphs/safety_03-ae-summary/data.json'
import safety_03hemaaes_JSON from '@/assets/graphs/safety_03-hema-aes/data.json'
import safety_03nonhemaaes_JSON from '@/assets/graphs/safety_03-non-hema-aes/data.json'

export default {
  name: 'App',
  components: {
    Vue3Lottie
  },
  mounted()
  {
    /*window.addEventListener('set_section', (e) => {
      alert(JSON.stringify(e));
    });*/

    window.addEventListener('message', this.receiveMessage, false);
  },
  methods:
  {
    receiveMessage(event) {
      if (event.type == "message" && event.data.set_section != undefined)
      {
        console.log(event.data.set_section);
        this.set_section(event.data.set_section);
        //console.log(event.type);
      }
      
      //alert(JSON.stringify(event));
    },
    enterFrame()
    {
      //console.log(this.$refs.interactive_1.getCurrentFrame());
    },
    animComplete()
    {
      
    },
    set_section_from_html(event)
    {
      alert(JSON.stringify(event));
      this.set_section(event.index);
    },
    set_section(index)
    {
      this.current_section = index;

      if (index == 1)
      {
        this.set_graph('baseline_01');
      }
      else if (index == 2)
      {
        this.set_graph('safety_01');
      }
      else if (index == 3)
      {
        this.set_graph('conclusions');
      }
    },
    startInteractive(index)
    {
      if (index == 1)
      {
        this.$refs.eff_os.playSegments([0, 257], true);
      }

      if (index == 2)
      {
        this.$refs.eff_os3.playSegments([0, 270], true);
      }

      if (index == 3)
      {
        this.$refs.eff_mos.playSegments([0, 195], true);
      }
    },
    set_graph(graph_index)
    {
      this.current_animation = graph_index;
      this.int_1_conc_shown = false;
      this.int_2_conc_shown = false;

      /*if (graph_index == "bc_ras")
      {
        setTimeout(() => {
          this.$refs.bc_ras.playSegments([0, 239], true);
          }, 500);
        
      }*/
    },
    play_bc_ras_end()
    {
      this.$refs.bc_ras.playSegments([243, 245], true);
    },
    int_click(int_index, btn_index)
    {
      if (int_index == 1)
      {
        if (btn_index == 1)
        {
          this.int_1_conc_shown = !this.int_1_conc_shown;
        }

        if (btn_index == 2)
        {
          this.int_2_conc_shown = !this.int_2_conc_shown;
        }
      }
    }
    
  },
  computed:
  {
    get_icon_class()
    {
      switch (this.current_animation)
      {
        case 'baseline_01':
          return 'nav_icon_01';
        case 'bc_age':
          return 'nav_icon_01';
        case 'bc_sex':
          return 'nav_icon_02';
        case 'bc_ras':
          return 'nav_icon_03';
        case 'bc_msi':
          return 'nav_icon_04';

        case 'bc_meta':
          return 'nav_icon_04';
        case 'bc_ds':
          return 'nav_icon_04';
        case 'bc_stage':
          return 'nav_icon_04';
        case 'bc_time':
          return 'nav_icon_04';
        case 'safety_01':
          return 'nav_icon_05';
        case 'safety_02':
          return 'nav_icon_06';

        case 'safety_03-ae-summary':
          return 'nav_icon_07';
        case 'safety_03-hema-aes':
          return 'nav_icon_07';
        case 'safety_03-non-hema-aes':
          return 'nav_icon_07';

          

        default:
          return 'icon_1';
      }
      
    }
  },
  data() {
    return {
      baseline_01_JSON,
      baseline_02age_JSON,
      baseline_02sex_JSON,
      baseline_03msi_JSON,
      baseline_03ras_JSON,
      baseline_dccrcstage_JSON,
      baseline_dcds_JSON,
      baseline_dcmeta_JSON,
      baseline_dctimesince_JSON,
      conclusions_JSON,
      safety_01_JSON,
      safety_02_JSON,
      safety_03aesummary_JSON,
      safety_03hemaaes_JSON,
      safety_03nonhemaaes_JSON,
      current_animation: "baseline_01",
      int_1_conc_shown: false,
      int_2_conc_shown: false,
      int_3_conc_shown: false,
      current_section: 1
    }
  },
}
</script>

<style>

@import "./css/style.css";

</style>
